module.exports = __webpack_public_path__ + "static/media/logo.ee5f13a2.jpg";